import { dinero, useTraduccion } from '@tallerya/i18n';
import { PanelLateral } from '@tallerya/ui';
import { textoDeEntrada, type Campos } from '../../componentes/historial/cambios';
import { LineaDeTiempo } from '../../componentes/historial/LineaDeTiempo';
import { useMoneda } from '../../datos/useMoneda';
import { useHistorialItem } from './datos';
import { horas } from './duracion';

// El panel «Historial» de la ficha de un producto o servicio (#181), con la
// línea de tiempo común. Acá los valores sí salen —«Precio de lista: 25,00 US$ →
// 30,00 US$»—: son datos del negocio, no de una persona.
//
// El precio llega sin cifras para quien no puede ver montos; hoy no pasa, porque
// la ficha ya pide `catalog.edit`, pero lo decide el servidor y no esta pantalla.

export function PanelHistorial({
  itemId,
  abierto,
  onCerrar,
}: {
  itemId: string;
  abierto: boolean;
  onCerrar: () => void;
}) {
  const { t, idioma } = useTraduccion();
  const moneda = useMoneda();
  const consulta = useHistorialItem(itemId, abierto);

  const campos: Campos = {
    code: { etiqueta: t('admin.catalogo.formulario.codigo') },
    name: { etiqueta: t('admin.catalogo.formulario.nombre') },
    category_id: {
      etiqueta: t('admin.catalogo.formulario.categoria'),
      vacio: t('admin.catalogo.formulario.sinCategoria'),
    },
    list_price: {
      etiqueta: t('admin.catalogo.formulario.precio'),
      // Como en la ficha: con la moneda del taller, o con dos decimales mientras llega.
      valor: (precio) => (moneda ? dinero(Number(precio), moneda, idioma) : Number(precio).toFixed(2)),
    },
    reference_duration_minutes: {
      etiqueta: t('admin.catalogo.formulario.duracion'),
      valor: (minutos) => horas(Number(minutos), idioma),
    },
    external_code: { etiqueta: t('admin.catalogo.formulario.codigoExterno') },
    aliases: {
      etiqueta: t('admin.catalogo.formulario.otrosNombres'),
      // El ítem los guarda separados por coma; se leen con su espacio.
      valor: (alias) => alias.split(',').join(', '),
    },
  };

  return (
    <PanelLateral abierto={abierto} onCerrar={onCerrar} titulo={t('admin.historial.titulo')} info={t('admin.catalogo.historial.info')}>
      <LineaDeTiempo consulta={consulta} texto={(entrada) => textoDeEntrada(entrada, campos, t)} />
    </PanelLateral>
  );
}
